import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, withKeys as _withKeys } from "vue";
const _hoisted_1 = {
  class: "mb-6"
};
const _hoisted_2 = {
  class: "mb-6"
};
const _hoisted_3 = {
  class: "mb-6"
};
const _hoisted_4 = {
  class: "flex"
};
const _hoisted_5 = {
  class: "w-8/12 pr-2"
};
const _hoisted_6 = {
  class: "w-4/12 pl-2"
};
const _hoisted_7 = {
  class: "mb-6"
};
const _hoisted_8 = {
  class: "d-block text-subtitle-2 font-weight-medium mb-2"
};
const _hoisted_9 = {
  class: "flex items-center"
};
const _hoisted_10 = {
  key: 0,
  class: "flex w-1/5"
};
const _hoisted_11 = {
  class: ""
};
const _hoisted_12 = {
  key: 0,
  class: "d-flex align-center justify-center"
};
const _hoisted_13 = {
  key: 1
};
const _hoisted_14 = {
  key: 0,
  class: "text-center py-2 px-3 rounded bg-green-100 text-base",
  "data-cy": "netdocs-status-message"
};
const _hoisted_15 = {
  key: 1,
  class: "text-center py-2 px-3 rounded bg-[rgba(var(--v-theme-error),0.08)]",
  "data-cy": "netdocs-warning"
};
const _hoisted_16 = {
  key: 2,
  class: "text-center py-2 px-3 rounded bg-[rgba(var(--v-theme-error),0.08)]",
  "data-cy": "netdocs-warning"
};
const _hoisted_17 = {
  key: 3,
  class: "text-center py-2 px-3 rounded bg-[rgba(var(--v-theme-error),0.08)]",
  "data-cy": "netdocs-warning"
};
import { reactive, onMounted, computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import LlTextarea from '@/components/LlTextarea.vue';
import LlTextField from '@/components/LlTextField.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import RouteService from '@/services/RouteService';
import useClientMatterStore from '@/services/useClientMatterStore';
import { useMeStore } from '@/services/UserService/useMeStore';
import LlTooltip from '@/components/LlTooltip.vue';
import ClientIdInput from '@/components/ClientIdInput.vue';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import { useNetDocsStore } from '@/services/useNetDocsStore.js';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import { isValidEmail } from '@/services/utils';
import SnackbarComponent from '@/components/SnackbarComponent.vue';
export default {
  __name: 'CreateClient',
  props: {
    stateParams: Object,
    state: Object,
    methodOverride: {
      type: String,
      default: ''
    },
    clientMatterManager: Object,
    isfromVue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'clientCreated'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const meStore = useMeStore();
    const {
      me,
      features
    } = storeToRefs(meStore);
    const clientMatterStore = useClientMatterStore();
    const routeService = new RouteService(props);
    const {
      companySettings
    } = storeToRefs(useCompanyStore());
    const {
      handleError
    } = useSnackbarHandler();
    const netDocsStore = useNetDocsStore();
    const {
      connected: netDocsConnected,
      isDisconnectedUnintentionally,
      loading: netDocsLoading
    } = storeToRefs(netDocsStore);
    const state = reactive({
      loading: true,
      loadingReference: false,
      client: {
        contact: {
          address: {}
        },
        method: ''
      },
      tempName: '',
      reference: '',
      nextReference: '',
      saving: false,
      clients: []
    });
    const clientExistsDialog = ref(null);
    const dialogOpen = ref(true);
    const companyExistsDialog = ref(null);
    const existingCompanyClient = ref(null);
    const modalRef = ref(null);
    const emit = __emit;
    onMounted(async () => {
      modalRef.value.focus();
      try {
        state.loading = true;
        await Promise.all([meStore.getMe(), initializeClient(), loadClients()]);
        state.loading = false;
        await loadNextReference();
        if (features?.value.netdocs) {
          await netDocsStore.checkStatus();
        }
      } catch (error) {
        handleError('Error loading initial data:', error);
      }
    });
    async function initializeClient() {
      state.client = {
        contact: {
          address: {}
        }
      };
      if (companySettings.value?.billClient) {
        state.client.billing = {
          billClient: true
        };
      }
    }
    async function loadClients() {
      try {
        const clients = await props.clientMatterManager.listClients({
          scope: 'all'
        });
        state.clients = Array.isArray(clients) ? clients : [];
        state.clientsWithReferences = state.clients.filter(c => c.reference && c.reference.trim());
      } catch (error) {
        handleError('Error loading clients:', error);
        state.clients = [];
      }
    }
    async function loadNextReference() {
      state.loadingReference = true;
      try {
        const result = await meStore.getMyCompanyReferences();
        state.nextReference = result.nextClientReference;
        state.reference = state.nextReference;
      } finally {
        state.loadingReference = false;
      }
    }
    async function startSave() {
      if (!state.tempName) {
        handleError('A company, contact person, or custom display name must be provided');
        return;
      }
      if (!formIsValid.value) {
        handleError('Your form is not valid. Please check the fields and try again.');
        return;
      }
      if (await checkForConflicts()) return;
      state.client.reference = state.reference;
      finishSave();
    }
    async function finishSave() {
      state.saving = true;
      const methodSource = state.client.method || props.stateParams?.methodOverride ||
      // from $state.go(..., { methodOverride: 'plus sign' })
      'client page';
      try {
        const response = await clientMatterStore.createClient({
          create: {
            ...state.client,
            method: methodSource
          }
        });
        if (!response) {
          return;
        }
        done(response, true);
      } catch (error) {
        handleError('Error creating client:', error);
      } finally {
        state.saving = false;
      }
    }
    function search(name, prop = 'name') {
      if (!Array.isArray(state.clients)) {
        return [];
      }
      const n = (name || '').toLowerCase();
      return state.clients.filter(c => c[prop] && c[prop].toLowerCase().includes(n));
    }
    async function selected(item) {
      const res = await clientExistsDialog.value.open();
      if (res) done(item, true);
    }
    function closeDialog() {
      dialogOpen.value = false;
      done();
    }
    function done(client, reload = false) {
      dialogOpen.value = false;
      if (!client) {
        if (props.isfromVue) {
          emit('close');
          return;
        }
        routeService.go('^');
        return;
      }
      if (props.isfromVue) {
        emit('clientCreated', client);
        return;
      }
      routeService.go('matters-next.matter2', {
        clientId: client?.id
      }, {
        reload
      });
    }
    function recalculateDisplayName() {
      if (state.client.contact.customName) return;
      state.tempName = '';
      if (state.client.contact.companyName) {
        state.tempName = state.client.contact.companyName;
        return;
      }
      state.tempName = formatPersonName(state.client.contact);
    }
    function formatPersonName(contact) {
      if (contact.last && contact.first) {
        return formatFullName(contact);
      } else if (contact.last) {
        return contact.last;
      } else if (contact.first) {
        return contact.first;
      }
      return '';
    }
    function formatFullName(contact) {
      return `${contact.last}, ${[contact.first, contact.middle, contact.suffix].filter(Boolean).join(' ')}`;
    }
    function customDisplayNameSet() {
      state.client.contact.customName = state.tempName;
    }
    async function checkForConflicts() {
      // Check for company name conflict when no client ID is provided
      if (!state.reference && checkCompanyConflict()) {
        const res = await companyExistsDialog.value.open();
        if (res) {
          done(existingCompanyClient.value, true);
        }
        return true;
      }
      return false;
    }
    function validateEmail(value) {
      if (!value) return true;
      return isValidEmail(value) || 'Please enter a valid email address. If providing multiple emails, separate with commas';
    }
    const formIsValid = computed(() => {
      // Required display name check
      if (!state.tempName) {
        return false;
      }

      // Email validation
      if (state.client.contact.email && !isValidEmail(state.client.contact.email)) {
        return false;
      }

      // CC email validation
      if (state.client.contact.cc && !isValidEmail(state.client.contact.cc)) {
        return false;
      }

      // Validate phone numbers (existing code)
      const phoneFields = [{
        value: state.client.contact.phone,
        label: 'Phone'
      }, {
        value: state.client.contact.cell,
        label: 'Cell'
      }, {
        value: state.client.contact.fax,
        label: 'Fax'
      }, {
        value: state.client.contact.other,
        label: 'Other phone'
      }];
      for (const field of phoneFields) {
        if (field.value) {
          const phoneResult = validatePhoneNumber(field.value);
          if (phoneResult !== true) {
            return false;
          }
        }
      }
      return true;
    });
    const netDocsVisible = computed(() => netDocsConnected.value && !state.loadingReference && !netDocsLoading.value);
    function handleItemSelected(item) {
      // Only run the selected check if we have a real item
      if (item && item.id !== state.client.id) {
        selected(item);
      }
      recalculateDisplayName();
    }
    function handleDisplayNameSelected(item) {
      state.tempName = item.name;
      checkForConflicts();
    }
    function checkCompanyConflict() {
      if (!state.tempName || state.reference) {
        return false;
      }
      const companyName = state.tempName.toLowerCase().trim();
      const existingClient = state.clients.find(client => client.contact?.companyName && client.contact.companyName.toLowerCase().trim() === companyName);
      if (existingClient) {
        existingCompanyClient.value = existingClient;
        return true;
      }
      return false;
    }
    function validatePhoneNumber(value) {
      if (!value) return true;
      return value.length <= 50 || 'Phone number should not exceed 50 characters';
    }
    function openDialog(typedValue = '', method = '') {
      dialogOpen.value = true;
      state.client.method = method;
      if (typedValue && typedValue.trim()) {
        state.client.contact.companyName = typedValue.trim();
        recalculateDisplayName();
      }
      modalRef.value?.focus();
    }
    __expose({
      openDialog
    });
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
      const _component_v_col = _resolveComponent("v-col");
      const _component_v_row = _resolveComponent("v-row");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_progress_circular = _resolveComponent("v-progress-circular");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_dialog = _resolveComponent("v-dialog");
      return _openBlock(), _createElementBlock("div", {
        onKeydown: _cache[21] || (_cache[21] = _withKeys($event => closeDialog(), ["esc"])),
        ref_key: "modalRef",
        ref: modalRef,
        tabindex: "0"
      }, [_createVNode(_component_v_dialog, {
        modelValue: dialogOpen.value,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => dialogOpen.value = $event),
        "max-width": "700px",
        "content-class": "client-edit-dialog"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card, null, {
          default: _withCtx(() => [_createVNode(_component_v_card_title, {
            class: "text-h5 px-6"
          }, {
            default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createTextVNode(" Create Client ", -1)]))]),
            _: 1
          }), state.loading ? (_openBlock(), _createBlock(_component_v_card_text, {
            key: 0,
            class: "pa-4"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_skeleton_loader, {
              type: "article, actions",
              class: "mb-6"
            }), _createElementVNode("div", _hoisted_1, [_createVNode(_component_v_skeleton_loader, {
              type: "heading",
              class: "mb-2"
            })]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_v_row, {
              dense: ""
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, n => {
                return _createVNode(_component_v_col, {
                  cols: "6",
                  key: n
                }, {
                  default: _withCtx(() => [_createVNode(_component_v_skeleton_loader, {
                    type: "text",
                    class: "mb-2"
                  })]),
                  _: 1
                });
              }), 64))]),
              _: 1
            })]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_v_skeleton_loader, {
              type: "paragraph",
              class: "mb-2"
            }), _createVNode(_component_v_row, {
              dense: ""
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, n => {
                return _createVNode(_component_v_col, {
                  cols: "6",
                  key: n
                }, {
                  default: _withCtx(() => [_createVNode(_component_v_skeleton_loader, {
                    type: "text",
                    class: "mb-2"
                  })]),
                  _: 1
                });
              }), 64))]),
              _: 1
            })])]),
            _: 1
          })) : (_openBlock(), _createBlock(_component_v_card_text, {
            key: 1,
            class: "pt-2 px-6",
            "data-cy": "client-detail"
          }, {
            default: _withCtx(() => [_createVNode(SnackbarComponent, {
              ref: "snackbar"
            }, null, 512), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(LlTextField, {
              id: "company",
              label: "Company",
              hideDetails: false,
              modelValue: state.client.contact.companyName,
              "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => state.client.contact.companyName = $event), recalculateDisplayName],
              "data-cy": "company-name-input"
            }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_6, [_createVNode(ClientIdInput, {
              id: "client-id",
              label: "Client Id",
              info: "An id or number that will be used to identify the client. You can set up automatic client numbers in settings.",
              items: state.clientsWithReferences,
              "item-title": "reference",
              "item-value": "reference",
              modelValue: state.reference,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => state.reference = $event),
              disabled: state.loadingReference,
              placeholder: state.loadingReference ? 'loading...' : '- Optional -',
              minWidth: "240",
              maxWidth: "300",
              onItemSelected: handleItemSelected,
              "data-cy": "client-id-input"
            }, null, 8, ["items", "modelValue", "disabled", "placeholder"])])]), _createElementVNode("div", _hoisted_7, [_cache[23] || (_cache[23] = _createElementVNode("label", {
              class: "d-block text-subtitle-2 font-weight-medium mb-2"
            }, "Contact", -1)), _createVNode(_component_v_row, {
              dense: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                cols: "2",
                class: "pr-2"
              }, {
                default: _withCtx(() => [_createVNode(LlTextField, {
                  placeholder: "Title",
                  modelValue: state.client.contact.title,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => state.client.contact.title = $event),
                  "data-cy": "contact-title-input"
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_v_col, {
                cols: "3",
                class: "px-2"
              }, {
                default: _withCtx(() => [_createVNode(LlTextField, {
                  placeholder: "First Name",
                  modelValue: state.client.contact.first,
                  "onUpdate:modelValue": [_cache[3] || (_cache[3] = $event => state.client.contact.first = $event), recalculateDisplayName],
                  "data-cy": "contact-first-name-input"
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_v_col, {
                cols: "2",
                class: "px-2"
              }, {
                default: _withCtx(() => [_createVNode(LlTextField, {
                  placeholder: "Middle Name",
                  modelValue: state.client.contact.middle,
                  "onUpdate:modelValue": [_cache[4] || (_cache[4] = $event => state.client.contact.middle = $event), recalculateDisplayName],
                  "data-cy": "contact-middle-name-input"
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_v_col, {
                cols: "3",
                class: "px-2"
              }, {
                default: _withCtx(() => [_createVNode(LlTextField, {
                  placeholder: "Last Name",
                  modelValue: state.client.contact.last,
                  "onUpdate:modelValue": [_cache[5] || (_cache[5] = $event => state.client.contact.last = $event), recalculateDisplayName],
                  "data-cy": "contact-last-name-input"
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_v_col, {
                cols: "2",
                class: "pl-2"
              }, {
                default: _withCtx(() => [_createVNode(LlTextField, {
                  placeholder: "Suffix",
                  modelValue: state.client.contact.suffix,
                  "onUpdate:modelValue": [_cache[6] || (_cache[6] = $event => state.client.contact.suffix = $event), recalculateDisplayName],
                  "data-cy": "contact-suffix-input"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]), _createElementVNode("div", null, [_createElementVNode("label", _hoisted_8, [_cache[25] || (_cache[25] = _createTextVNode(" Display Name ", -1)), _cache[26] || (_cache[26] = _createElementVNode("span", {
              class: "font-weight-bold mr-1"
            }, "*", -1)), _createVNode(LlTooltip, {
              icon: "help"
            }, {
              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [_createTextVNode(" The name that will show up in the application to identify this client.", -1), _createElementVNode("br", null, null, -1), _createTextVNode("The display name includes the Client Id at the front of it, if the Client Id exists.", -1), _createElementVNode("br", null, null, -1), _createElementVNode("i", null, "Ex: 0010- Last, First", -1)]))]),
              _: 1
            })]), _createElementVNode("div", _hoisted_9, [state.reference ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(LlTextField, {
              modelValue: state.reference,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => state.reference = $event),
              disabled: "",
              hideDetails: false
            }, null, 8, ["modelValue"]), _cache[27] || (_cache[27] = _createElementVNode("div", {
              class: "px-2 pt-2"
            }, "-", -1))])) : _createCommentVNode("", true), _createElementVNode("div", {
              class: _normalizeClass(["w-4/5", {
                'w-full': !state.reference
              }])
            }, [_createVNode(ClientIdInput, {
              modelValue: state.tempName,
              "onUpdate:modelValue": [_cache[8] || (_cache[8] = $event => state.tempName = $event), customDisplayNameSet],
              items: search(state.tempName),
              "item-title": "name",
              "item-value": "name",
              placeholder: "Name",
              rules: [v => !!v || 'This field is required.'],
              "data-cy": "display-name-input",
              onItemSelected: handleDisplayNameSelected,
              minWidth: "440",
              maxWidth: "500"
            }, null, 8, ["modelValue", "items", "rules"])], 2)])]), _createElementVNode("div", null, [_createVNode(_component_v_row, {
              dense: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                cols: "6",
                class: "pr-2"
              }, {
                default: _withCtx(() => [_createVNode(LlTextField, {
                  id: "email",
                  label: "Email",
                  modelValue: state.client.contact.email,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => state.client.contact.email = $event),
                  placeholder: "Separate multiple emails with commas",
                  rules: [validateEmail],
                  hideDetails: false,
                  "data-cy": "contact-email-input"
                }, null, 8, ["modelValue", "rules"])]),
                _: 1
              }), _createVNode(_component_v_col, {
                cols: "6",
                class: "pl-2"
              }, {
                default: _withCtx(() => [_createVNode(LlTextField, {
                  id: "emailcc",
                  label: "Email CC",
                  modelValue: state.client.contact.cc,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => state.client.contact.cc = $event),
                  placeholder: "Separate multiple emails with commas",
                  rules: [validateEmail],
                  hideDetails: false,
                  "data-cy": "contact-email-cc-input"
                }, null, 8, ["modelValue", "rules"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_v_row, {
              dense: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                cols: "6",
                class: "pr-2"
              }, {
                default: _withCtx(() => [_createVNode(LlTextField, {
                  incomingName: "phone",
                  type: "tel",
                  label: "Phone",
                  modelValue: state.client.contact.phone,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => state.client.contact.phone = $event),
                  placeholder: "Main Phone",
                  hideDetails: false,
                  rules: [validatePhoneNumber],
                  "data-cy": "contact-phone-input"
                }, null, 8, ["modelValue", "rules"])]),
                _: 1
              }), _createVNode(_component_v_col, {
                cols: "6",
                class: "pl-2"
              }, {
                default: _withCtx(() => [_createVNode(LlTextField, {
                  incomingName: "cell",
                  type: "tel",
                  label: "Cell",
                  modelValue: state.client.contact.cell,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => state.client.contact.cell = $event),
                  placeholder: "Cell Phone",
                  hideDetails: false,
                  rules: [validatePhoneNumber],
                  "data-cy": "contact-cell-input"
                }, null, 8, ["modelValue", "rules"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_v_row, {
              dense: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                cols: "6",
                class: "pr-2"
              }, {
                default: _withCtx(() => [_createVNode(LlTextField, {
                  incomingName: "fax",
                  type: "tel",
                  label: "Fax",
                  modelValue: state.client.contact.fax,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => state.client.contact.fax = $event),
                  placeholder: "Fax",
                  hideDetails: false,
                  rules: [validatePhoneNumber],
                  "data-cy": "contact-fax-input"
                }, null, 8, ["modelValue", "rules"])]),
                _: 1
              }), _createVNode(_component_v_col, {
                cols: "6",
                class: "pl-2"
              }, {
                default: _withCtx(() => [_createVNode(LlTextField, {
                  incomingName: "other",
                  type: "tel",
                  label: "Other",
                  modelValue: state.client.contact.other,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => state.client.contact.other = $event),
                  placeholder: "Other Phone",
                  hideDetails: false,
                  rules: [validatePhoneNumber],
                  "data-cy": "contact-other-input"
                }, null, 8, ["modelValue", "rules"])]),
                _: 1
              })]),
              _: 1
            })]), _createElementVNode("div", _hoisted_11, [_createVNode(LlTextarea, {
              label: "Invoicing Address",
              modelValue: state.client.contact.address.address,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => state.client.contact.address.address = $event),
              placeholder: "Street address, P.O. box\nApartment, suite, unit, building, floor, etc.",
              rows: 2,
              hideDetails: false,
              "data-cy": "invoicing-address-input"
            }, null, 8, ["modelValue"]), _createVNode(_component_v_row, {
              dense: "",
              class: "mt-2"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                cols: "6",
                class: "pr-2"
              }, {
                default: _withCtx(() => [_createVNode(LlTextField, {
                  modelValue: state.client.contact.address.city,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => state.client.contact.address.city = $event),
                  placeholder: "City / Town",
                  hideDetails: false,
                  "data-cy": "address-city-input"
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_v_col, {
                cols: "6",
                class: "pl-2"
              }, {
                default: _withCtx(() => [_createVNode(LlTextField, {
                  modelValue: state.client.contact.address.state,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => state.client.contact.address.state = $event),
                  placeholder: "State / Province / Region",
                  hideDetails: false,
                  "data-cy": "address-state-input"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_v_row, {
              dense: "",
              class: "mt-2"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                cols: "6",
                class: "pr-2"
              }, {
                default: _withCtx(() => [_createVNode(LlTextField, {
                  modelValue: state.client.contact.address.zip,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => state.client.contact.address.zip = $event),
                  placeholder: "ZIP / Postal code",
                  hideDetails: false,
                  "data-cy": "address-zip-input"
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_v_col, {
                cols: "6",
                class: "pl-2"
              }, {
                default: _withCtx(() => [_createVNode(LlTextField, {
                  modelValue: state.client.contact.address.country,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => state.client.contact.address.country = $event),
                  placeholder: "Country",
                  hideDetails: false,
                  "data-cy": "address-country-input"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]), _unref(netDocsLoading) ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_v_progress_circular, {
              color: "success",
              indeterminate: ""
            })])) : _createCommentVNode("", true), netDocsVisible.value ? (_openBlock(), _createElementBlock("div", _hoisted_13, [state.reference && !_unref(isDisconnectedUnintentionally) ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Client will be created or matched in NetDocuments upon creation in LeanLaw. ")) : _createCommentVNode("", true), state.reference && _unref(isDisconnectedUnintentionally) && _unref(me).access.setup ? (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[28] || (_cache[28] = [_createTextVNode(" Client will not be created in NetDocuments because LeanLaw and NetDocuments are disconnected. Go to ", -1), _createElementVNode("a", {
              "ui-sref": "settings.company.netdocs",
              class: "text-primary"
            }, "Settings", -1), _createTextVNode(" to reconnect. ", -1)]))])) : _createCommentVNode("", true), state.reference && _unref(isDisconnectedUnintentionally) && !_unref(me).access.setup ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Client will not be created in NetDocuments because LeanLaw and NetDocuments are disconnected. Please contact someone in your firm who has access to NetDocuments settings to reconnect. ")) : _createCommentVNode("", true), !state.reference ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Client cannot be created in NetDocuments because it's missing Client ID ")) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
            _: 1
          })), _createVNode(_component_v_card_actions, {
            class: "d-flex justify-space-between px-6 pb-4"
          }, {
            default: _withCtx(() => [_createVNode(LlSecondaryButton, {
              onBtnClick: closeDialog,
              "data-cy": "cancel-client-button"
            }, {
              default: _withCtx(() => [...(_cache[29] || (_cache[29] = [_createTextVNode(" Cancel ", -1)]))]),
              _: 1
            }), _createVNode(LlSecondaryButton, {
              id: "save-client-button",
              color: "primary",
              variant: "flat",
              disabled: !formIsValid.value || state.saving,
              isSaving: state.saving,
              onBtnClick: startSave,
              "data-cy": "save-client-button"
            }, {
              default: _withCtx(() => [...(_cache[30] || (_cache[30] = [_createTextVNode(" Create Client ", -1)]))]),
              _: 1
            }, 8, ["disabled", "isSaving"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(LlConfirmationDialog, {
        ref_key: "clientExistsDialog",
        ref: clientExistsDialog,
        title: "Client Already Exists",
        message: "A client with this id is already in the system. Use that client instead of creating a new one?",
        "confirm-text": "Use Existing",
        "toggle-text": "Create New",
        "data-cy": "client-conflict-dialog"
      }, null, 512), _createVNode(LlConfirmationDialog, {
        ref_key: "companyExistsDialog",
        ref: companyExistsDialog,
        title: "Company Already Exists",
        message: `A client with the company name '${state.tempName}' already exists in the system. Use that client instead of creating a new one?`,
        "confirm-text": "Use Existing",
        "toggle-text": "Create New",
        "data-cy": "company-conflict-dialog"
      }, null, 8, ["message"])], 544);
    };
  }
};